var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.92801C8.09599 4.92801 4.92799 8.08534 4.92799 11.9893C4.92693 15.8827 8.08533 19.0507 11.9893 19.0507C15.8827 19.0507 19.0507 15.8827 19.0507 11.9787C19.0507 8.07468 15.8827 4.90668 11.9787 4.90668L12 4.92801ZM5.94133 11.9893C5.94133 8.64001 8.63999 5.93068 11.9893 5.93068C15.328 5.93068 18.0373 8.62934 18.0373 11.9787C18.0373 15.3173 15.328 18.0267 11.9787 18.0267C8.62933 18.0267 5.91999 15.3173 5.91999 11.968L5.94133 11.9893ZM12.5227 8.78934C12.5227 8.49068 12.2773 8.25601 11.9893 8.25601C11.6907 8.25601 11.456 8.49068 11.456 8.78934V11.9893C11.456 12.128 11.5093 12.256 11.6053 12.3627L13.7387 14.496C13.9413 14.6987 14.2827 14.6987 14.4853 14.496C14.688 14.2827 14.688 13.9413 14.4853 13.7387L12.5013 11.7547V8.76801L12.5227 8.78934Z",
    fill: "#9DA6AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateIcon);
export default __webpack_public_path__ + "static/media/date-icon.18ac0b71d826851500457219955b2949.svg";
export { ForwardRef as ReactComponent };